<template>
  <div
    class="base-input"
    :class="{ error: hasValidationError }"
    :style="{ width }"
  >
    <label
      @click="() => !readonly && $refs.input.focus()"
      v-if="label && readonly"
      :class="['input__label', { readonly }]"
      >{{ label }}</label
    >

    <input
      autocomplete="off"
      ref="input"
      v-model="inputValue"
      :name="name"
      type="text"
      class="input__field"
      :placeholder="placeholder"
      :readonly="readonly"
      :disabled="disabled"
    />

    <svgicon
      @click="$emit('copy')"
      class='icon'
      icon="copy"
      width='16px'
    />
  </div>
</template>

<script>
import Base from "./Base/Base";

export default {
  name: "vcopy",
  extends: Base
}
</script>

<style lang="scss" scoped>
.icon {
  position: absolute;
  right: 13px;
  top: 16px;
  fill: $dark-blue;
  transition: fill 0.2s;
  cursor: pointer;
}
</style>
